module.exports = __webpack_public_path__ + "assets/img/loading.79deed6.gif";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/loading.gif
// module id = 226
// module chunks = 66